module.exports = __webpack_public_path__ + "img/no-data.c6d67107.png";